import { ConcreteEncodable } from "./ConcreteEncodable";

import { NettingPairImplEncoder } from "../../encoder/NettingPairImplEncoder";

import * as CubiqTS from "../../index";
import { NettingPair } from "../NettingPair";

export class NettingPairImpl extends ConcreteEncodable implements NettingPair {
  public static enType: string = "com.bcdfx.model.event.NettingPairImpl";

  /*FID=1*/
  public portfolioId: string;
  /*FID=2*/
  public orderId: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = NettingPairImplEncoder.Instance;
    this.setEncodableType(NettingPairImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "NettingPairImpl[" +
      "portfolioId=" +
      this.portfolioId +
      "orderId=" +
      this.orderId +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
